import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  apiUrl = environment.apiUrl

  constructor(private http:HttpClient) { }

  addProduct(body:any): Observable<any> {
    return this.http.post(`${this.apiUrl}adminaddProduct`,body)
  }
  
  getProducts(val?:any): Observable<any> {
    return this.http.post(`${this.apiUrl}getProducts`,val)
  }
  getProductsById(id): Observable<any> {
    return this.http.get(`${this.apiUrl}getProductProductId/${id}`)
  }

  updateProduct(body:any): Observable<any>{
    return this.http.post(`${this.apiUrl}updateadminProduct`,body)
  }
  deleteProduct(body:any): Observable<any>{
    return this.http.delete(`${this.apiUrl}delProduct/${body}`)
  }
  bulkDelete(body:any): Observable<any>{
    return this.http.post(`${this.apiUrl}multipleDelete`,body)
  }
  getLocation(data:any):Observable<any>{
    return this.http.get(`${this.apiUrl}getLocationById/${data}`)
  }
  getAllLocations(): Observable<any> {
    return this.http.get(`${this.apiUrl}getAllLocations`)
  }
  ActiveUserSubscriptions(data:any):Observable<any>{
    return this.http.get(`${this.apiUrl}ActiveUserSubscriptions?user_id=${data}`)
  }
  getPlans():Observable<any>{
    return this.http.get(`${this.apiUrl}getPlans`)
  }

  getSubScriptionPlan():Observable<any>{
    return this.http.get(`${this.apiUrl}getSubScriptionPlan`)
  }

  updatePlans(body):Observable<any> {
    return this.http.post(`${this.apiUrl}updatePlans`,body)
  }

}
